export default __webpack_public_path__ + "static/badge-dont-2-bold-light-506c62c90c39624e816754898c51099e.png";